import {Component, computed, inject, model} from '@angular/core';
import {MatDialogRef} from "@angular/material/dialog";

@Component({
    selector: 'app-trip-details-modal',
    templateUrl: './trip-details-modal.component.html',
    standalone: false
})
export class TripDetailsModalComponent {
  private readonly dialogRef = inject(MatDialogRef<TripDetailsModalComponent>);

  public readonly tripId = model.required<number>();

  protected readonly data = computed(() => ({
    tripId: this.tripId()
  }))

  protected close() {
    this.dialogRef.close();
  }
}
